import { useTranslation } from "react-i18next";
import { usePaginatedData } from "../../Hooks/usePaginatedData";
import { useEffect, useState } from "react";
import { PageLayout } from "../../Components/PageLayout";
import { TablePlaceHolder } from "../../Components/LoadingAnimations/LoadingAnimations";
import instance from "../../Interceptor/api_instance";
import { formatReadableDateTime } from "../../Helper/FormatDatetimes";
import SelectedStock from "./Modals/SelectedStock";
import { TableNavigation } from "../../Components/Tables/Vehicles/TableNavigation";
import { usePaginatedQuery } from "../../Hooks/usePaginatedQuery";

const StockLogsView = () => {
  const { t } = useTranslation();
  const { state, dispatch } = usePaginatedQuery("safety/stocklogs/");
  const [selectedRow, setSelectedRow] = useState(null);
  useEffect(() => {
    const ctrl = new AbortController();

    (async () => {
      try {
        dispatch({ type: "IS_LOADING", payload: true });
        dispatch({ type: "FETCH_DATA" });

        const res = await instance.get(state.currentPage, {
          signal: ctrl.signal,
        });
        if (res.status === 200) {
          dispatch({ type: "STORE_DATA", payload: res.data });
        }
      } catch (e) {
        console.log(e);
      } finally {
        dispatch({ type: "IS_LOADING", payload: false });
      }
    })();

    return () => ctrl.abort();
  }, [state.currentPage]);

  const headers = [
    t("yard-tables.table-columns.created_at"),
    t("yard-tables.table-columns.name"),
    t("yard-tables.table-columns.type"),
    t("yard-tables.table-columns.location"),
    t("forms.type.maintenance-report.labels.quantity"),
    t("general.note"),
    t("forms.type.maintenance-report.labels.created-by"),
    "Previous Price",
    "Unit Price",
  ];
  return (
    <PageLayout title={"Stock Logs"}>
      {selectedRow && (
        <SelectedStock data={selectedRow} close={() => setSelectedRow(null)} />
      )}
      <div className="search-filters-cont">
        <div className="search-filters">
          <TableNavigation state={state} dispatch={dispatch} />
        </div>
      </div>
      {state.isLoading ? (
        <TablePlaceHolder />
      ) : (
        <div className="table-cont">
          <table id="forwardTable" className="yard-table">
            <thead>
              <tr className="table-header">
                {headers.map((header, index) => (
                  <th key={index}>{header}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {state.data.map((log, index) => (
                <tr
                  className="data-rows row-hover gray"
                  onClick={() => setSelectedRow(log)}
                >
                  <td>{formatReadableDateTime(log.created_at)}</td>
                  <td>
                    {log.stock.part.sku}/{log.stock.part.name}
                  </td>
                  <td>{log.change_type}</td>
                  <td>{log.stock.location.loc_name}</td>
                  <td>{log.quantity_changed}</td>
                  <td>{log.note}</td>
                  <td>
                    {log.changed_by.first_name} {log.changed_by.last_name}
                  </td>
                  <td>{log.previous_unit_price}</td>
                  <td>{log.unit_price}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </PageLayout>
  );
};

export default StockLogsView;
